import React from "react";
import styled from "styled-components";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Spinner from "./Spinner";

export type ButtonProps = {
    children?: React.ReactNode;
    style?: React.CSSProperties;
    type?: "button" | "submit" | "reset";
    color?: string;
    textColor?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    disabled?: boolean;
    icon?: IconDefinition;
    active?: boolean;
    loading?: boolean;
    className?: string;
};

const ButtonElement = styled.button<{ backgroundColor: string; color: string }>`
    position: relative;
    border: none;
    appearance: none;
    cursor: pointer;
    padding: 0.33em 1em;
    background: ${(props) => props.backgroundColor};
    color: ${(props) => props.color};
    font-size: inherit;
    font-weight: bold;
    border-radius: 0.85em;
    border: 0.25em solid #0000;
    transition: 50ms;

    @media only screen and (min-width: 600px) {
        &:hover:not(:disabled) {
            transition: 50ms;
            border: 0.25em solid ${(props) => props.backgroundColor};
            background: transparent;
            color: ${(props) => props.backgroundColor};
        }
    }

    &.active {
        border: 0.25em solid ${(props) => props.backgroundColor};
        background: transparent;
        color: ${(props) => props.backgroundColor};
    }

    &:disabled {
        background: lightgray;
    }
`;

const Icon = styled(FontAwesomeIcon)`
    display: inline-block;
    margin: 0 0 0 1em;
    transform: scale(1.25);
    transition: 100ms;
`;

export default function Button(props: ButtonProps) {
    return (
        <ButtonElement
            backgroundColor={props.color ?? "#ec454f"}
            color={props.textColor ?? "white"}
            type={props.type}
            style={props.style}
            onClick={props.onClick}
            disabled={props.disabled}
            className={props.className + (props.active ? " active" : "")}
        >
            {props.loading && <Spinner style={{ margin: "0 0.5em" }} />}
            {props.children}
            {props.icon && <Icon icon={props.icon} />}
        </ButtonElement>
    );
}
